export const COURSE_FORM_TABS = [
  { id: 'general', label: 'General', icon: 'description' },
  { id: 'organization', label: 'Organización', icon: 'account_tree' },
  { id: 'configuration', label: 'Configuración', icon: 'settings' },
  { id: 'requirements', label: 'Requisitos', icon: 'rule' },
  { id: 'academic', label: 'Datos académicos', icon: 'school' },
  { id: 'seo', label: 'SEO', icon: 'search' },
] as const;

export type CourseFormTabId = (typeof COURSE_FORM_TABS)[number]['id'];

export const COURSE_STATUS_OPTIONS = [
  { value: 'draft', label: 'Borrador' },
  { value: 'published', label: 'Publicado' },
  { value: 'archived', label: 'Archivado' },
] as const;

export const COURSE_VISIBILITY_OPTIONS = [
  { value: 'public', label: 'Público' },
  { value: 'private', label: 'Privado' },
  { value: 'enrolled_only', label: 'Solo inscritos' },
] as const;

export function slugify(value: string | null | undefined) {
  return String(value ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function slugPlaceholder(name: string | null | undefined, code: string | null | undefined) {
  const namePart = slugify(name);
  const codePart = slugify(code);
  if (namePart && codePart) return `${namePart}-${codePart}`;
  return namePart || codePart || 'arquitectura-sistemas-cs-202';
}

export function fieldTabForElement(element: HTMLElement): CourseFormTabId {
  const id = element.id;
  const name = (element as HTMLInputElement).name ?? '';

  if (
    ['course-name', 'course-code', 'course-status', 'course-slug', 'course-short-description'].includes(id) ||
    ['full_description', 'fullDescription', 'shortDescription'].includes(name)
  ) {
    return 'general';
  }
  if (
    ['course-category', 'course-visibility', 'course-instructor'].includes(id) ||
    ['category_id', 'categoryId', 'visibility', 'primary_instructor_id', 'primaryInstructorId'].includes(name)
  ) {
    return 'organization';
  }
  if (id === 'course-price' || name === 'price') return 'configuration';
  if (
    ['course-requires-prerequisite', 'course-prerequisite', 'course-prerequisite-assessment'].includes(id) ||
    ['requiresPrerequisiteCourse', 'prerequisiteCourseId', 'prerequisiteAssessmentId'].includes(name)
  ) {
    return 'requirements';
  }
  if (['course-min-compliance-percent', 'course-academic-hours', 'course-start', 'course-end', 'course-max'].includes(id)) {
    return 'academic';
  }
  if (
    ['course-meta-title', 'course-meta-description'].includes(id) ||
    ['meta_title', 'meta_description'].includes(name)
  ) {
    return 'seo';
  }
  return 'general';
}
